import React from "react";

const HeaderPolestar = () => (
  <div id="Header">
    <div id="HeaderContainerPolestar">
      <div className="polestar-header-name-1">Polestar</div>
      <div className="polestar-header-name-2">Assistance</div>
    </div>
  </div>
);

export default HeaderPolestar;
